import React, { useEffect, useState } from "react";
import { action, useDsp } from "app/store";
import { apiProfilePerformers, apiProfilePerformersPaginate } from "app/api";
import { SectionProfilePerformers } from "blocks/profile";

export const WrapperProfilePerformers = () => {
  const dispatch = useDsp();
  const [nextPageUrl, setNextPageUrl] = useState<string | null>(null);

  const apiSuccess = ({ status, data }: any) => {
    // console.log("API PROFILE PERFORMERS SUCCESS", data);
    if (status === 200 && data) {
      const wishes = data.results || [];
      dispatch(action.dataProfilePrfsSet({ newData: wishes }));
      dispatch(action.loaderProfilePrfsSet(false));
      setNextPageUrl(data.next);
    }
  };

  const apiPaginationSuccess = ({ status, data }: any) => {
    // console.log("API PROFILE PAGINATE PERFORMERS SUCCESS", data);
    if (status === 200 && data && data.results && data.results.length > 0) {
      const wishes = data.results || [];
      dispatch(action.dataProfilePrfsSet({ paginatedData: wishes }));
      dispatch(action.loaderProfilePrfsSet(false));
      setNextPageUrl(data.next);
    }
  };

  const apiError = () => {
    // console.log("API PROFILE PERFORMERS ERROR", err);
    dispatch(action.loaderProfilePrfsSet(false));
  };

  const apiPaginationError = () => {
    // console.log("API PROFILE WISHES ERROR", err);
    dispatch(action.loaderProfileWishesSet(false));
  };

  useEffect(() => {
    apiProfilePerformers(apiSuccess, apiError);
    dispatch(action.loaderProfilePrfsSet(true));
  }, []);

  useEffect(() => {
    if (nextPageUrl) {
      apiProfilePerformersPaginate(
        nextPageUrl,
        apiPaginationSuccess,
        apiPaginationError
      );
      dispatch(action.loaderProfileWishesSet(true));
      setNextPageUrl(null);
    }
  }, [nextPageUrl]);

  return <SectionProfilePerformers />;
};
